import * as Sentry from "@sentry/browser";

export default function (exception) {
  if (Sentry.isInitialized()) {
    Sentry.captureException(exception);
  } else {
    console.error(exception);
  } 
}

export function captureSentryMessage(message, level = 'info') {
  if (Sentry.isInitialized()) {
    Sentry.captureMessage(message, level);
  } else {
    console.log(`Sentry message [${level}]:`, message);
  }
}
